import { DataRetentionSettingsMutations } from './partials/dataRetention'
import { DocketwiseSettingsMutations } from './partials/docketwise'
import { EngagementLetterMutations } from './partials/engagementLetter'
import { GenericModelSettingsMutations } from './partials/genericModel'
import { InvoicedSettingsMutations } from './partials/invoiced'
import { LegalCasePartySliderSettingsMutations } from './partials/legalCasePartySlider'
import { LegalCasesSettingsMutations } from './partials/legalCases'
import { MaintenanceSettingsMutations } from './partials/maintenance'
import { MiscSettingsMutations } from './partials/misc'
import { MultifactorAuthenticationSettingsMutations } from './partials/multifactorAuthentication'
import { OtherDocketEntriesSettingsMutations } from './partials/otherDocketEntries'
import { PermissionsSettingsMutations } from './partials/permissions'
import { RecordsSettingsMutations } from './partials/records'
import { SessionManagementSettingsMutations } from './partials/sessionManagement'
import { SettingsSharedMutations } from './partials/shared'
import { SharepointSettingsMutations } from './partials/sharepoint'
import { TimezoneSettingsMutations } from './partials/timezone'
import { TmetricSettingsMutations } from './partials/tmetric'
import { TwilioSettingsMutations } from './partials/twilio'
import { UserAccessSettingsMutations } from './partials/usersAccess'
import { UserSettingsMutations } from './partials/user'
import { WorkflowSettingsMutations } from './partials/workflows'

export const SettingsMutations = {
  ...DataRetentionSettingsMutations,
  ...DocketwiseSettingsMutations,
  ...EngagementLetterMutations,
  ...GenericModelSettingsMutations,
  ...InvoicedSettingsMutations,
  ...LegalCasePartySliderSettingsMutations,
  ...LegalCasesSettingsMutations,
  ...MaintenanceSettingsMutations,
  ...MiscSettingsMutations,
  ...MultifactorAuthenticationSettingsMutations,
  ...OtherDocketEntriesSettingsMutations,
  ...PermissionsSettingsMutations,
  ...RecordsSettingsMutations,
  ...SessionManagementSettingsMutations,
  ...SettingsSharedMutations,
  ...SharepointSettingsMutations,
  ...TimezoneSettingsMutations,
  ...TmetricSettingsMutations,
  ...TwilioSettingsMutations,
  ...UserAccessSettingsMutations,
  ...UserSettingsMutations,
  ...WorkflowSettingsMutations,
}
